import {useSelector} from 'react-redux';
import {applicationSelector} from '../../slices/application';
import ChooseQuantity from './Quantity/ChooseQuantity';
import ChooseTubingForm from './Tubing/ChooseTubingForm';
import './Forms.scss';
import AddEditArt from './Print/AddEditArt';
import AddEditText from './Print/AddEditText';
import SelectArt from './Print/SelectArt';
import SelectOptions from './Print/SelectOptions';

/**
 * Forms - State-based form switching component.
 * Renders forms based on Redux state (appTab/printTab) without React Router.
 *
 * @param {Object} props
 * @param {function} props.onNavigateToConfirm - Callback when navigating to confirm view
 * @param {function} props.onOrderSubmit - Callback when order is submitted
 */
const Forms = ({onNavigateToConfirm, onOrderSubmit}) => {
  const {appTab, printTab, heatshrinkCompatibility} = useSelector(applicationSelector);

  const renderForm = () => {
    switch (appTab) {
      case 'choose-tubing':
        return <ChooseTubingForm compatibility={heatshrinkCompatibility} />;
      case 'choose-quantity':
        return <ChooseQuantity onNavigateToConfirm={onNavigateToConfirm} onOrderSubmit={onOrderSubmit} />;
      case 'choose-print':
        switch (printTab) {
          case 'add-art':
          case 'edit-art':
            return <AddEditArt />;
          case 'add-text':
          case 'edit-text':
            return <AddEditText />;
          case 'select-art':
            return <SelectArt />;
          case 'select-options':
          default:
            return <SelectOptions />;
        }
      default:
        return <ChooseTubingForm compatibility={heatshrinkCompatibility} />;
    }
  };

  return <div className="hs-forms">{renderForm()}</div>;
};

export default Forms;
